import clsx from "clsx"
import { CSSProperties, ReactNode } from "react"
import { FormattedMessage } from "react-intl"
import Scrollbar from "simplebar-react"
import "./style.sass"

export interface ITableHead {
  label?: ReactNode
  key: string
  className?: string
  style?: CSSProperties
  centered?: boolean
  hidden?: boolean
  label_id?: string
}
interface ITableProps {
  heads: ITableHead[]
  data: Record<string, ReactNode>[]
  className?: string
  onRowClick?: (row: Record<string, ReactNode>) => void
  classNames?: {
    header?: string
    row?: string
  }
  loading?: boolean
}
export const Table = ({ loading, className, classNames, heads, data, onRowClick }: ITableProps) => {
  return (
    <Scrollbar>
      <table className={clsx("custom-table", className)}>
        <thead>
          <tr className={clsx("custom-table__head", classNames?.header)}>
            {heads.map(({ label_id, label, key, className, style, centered }) => (
              <th
                key={key}
                className={clsx("custom-table__head-cell", className)}
                style={{ textAlign: centered ? "center" : "initial", ...(style ?? {}) }}
              >
                {label_id != null ? <FormattedMessage id={label_id} /> : label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {loading ? (
            <tr>
              <td colSpan={heads.length} className="text-center">
                Loading...
              </td>
            </tr>
          ) : (
            data.map((row, id) => (
              <tr
                key={id}
                className={clsx("custom-table__body-row", classNames?.row, onRowClick != null && "cursor-pointer")}
                onClick={() => onRowClick?.(row)}
              >
                {heads.map((head) => (
                  <td key={head.key} className="custom-table__body-cell">
                    {row[head.key]}
                  </td>
                ))}
              </tr>
            ))
          )}
        </tbody>
      </table>
    </Scrollbar>
  )
}
